export default __webpack_public_path__ + "static/media/arrow.48b6917f.svg";